<template>
	<table
		class="table-list"
		border="0"
		cellpadding="0"
		cellspacing="0">
		<thead class="primary">
			<tr v-if="inputSearch || filterColumns || includeFilter || addButton">
				<th :colspan="totalVisibleColumns" :class="`text-xs-${direction}`">
					<div
						class="search-input align-center"
						v-if="inputSearch">
						<input
							v-model="search"
							type="text"
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
						/>
						<v-icon
							color="white"
							size="20"
						>
							search
						</v-icon>
					</div>
					<v-menu
						offset-y
						max-height="300"
						content-class="columns-menu"
						fixed
						v-model="showMenu"
						v-if="filterColumns"
						:close-on-content-click="false">
						<button type="button" slot="activator">
							<v-icon color="white">view_column</v-icon>
						</button>
						<div class="content-checkbox">
							<v-checkbox
								v-model="column.checked"
								:label="column.name"
								v-for="column in columns"
								:key="column.id"
								hide-details
								v-if="!column.flagVisible"
								color="success"
								class="filter-columns"
								style="background: white;width: 300px; line-height: normal">
							</v-checkbox>
							<div class="apply text-xs-center">
								<v-btn @click="toggleColumns" class="btn-action mb-2 mt-2" color="primary">Aplicar</v-btn>
							</div>
						</div>
					</v-menu>
					<button
						v-if="includeFilter"
						type="button"
						@click="tableOption">
						<v-icon>filter_list</v-icon>
					</button>
					<button
						v-if="addButton"
						type="button"
						@click="addOption">
						<v-icon>add</v-icon>
					</button>
				</th>
			</tr>
			<tr>
				<th v-if="selectable">
					<input
						type="checkbox"
						:value="checkAll"
						:checked="checkAll"
						class="input-checkbox"
						v-on:change="selectedAll($event)"
						:disabled="disabledTable">
				</th>
				<th is="table-column-item" v-for="column in columns" v-bind:key="column.id"
				  v-bind:column="column" v-show="column.visible" class="text-xs-center">
				</th>
			</tr>
		</thead>
		<tbody>
			<template>
				<tr v-for="row in rows"
					v-bind:key="row[keyValue]"
					:class="{ 
						'row-checked' : row[selectedValue],
						'row-maintenance': rowMaintenance && row.flagMaintenance }"
					>
					<td v-if="selectable">
						<input
							@click="rowIsSelected(row)"
							type="checkbox"
							v-model="row[selectedValue]"
							class="input-checkbox"
							:disabled="row.disabled">
					</td>
					<slot name="rows" v-bind:row="row"></slot>
				</tr>
			</template>
		</tbody>
		<tfoot class="table-pagination">
			<tr v-if="mainList && rows.length > 0">
				<td :colspan="totalVisibleColumns" class="text-xs-right">
					<input
						type="text"
						@input="selectPage($event.target.value)"
						:value="currentPage"
						class="search-input unique-input">
					<a
						v-for="(page, index) in pages"
						:key="index"
						:class="{ 'active-page': page === currentPage }"
						@click="selectPage(page)">{{page}}</a>
					<span>|</span>
					<a @click="selectLastPage">>></a>
				</td>
			</tr>
			<tr v-if="rows.length === 0">
				<td :colspan="totalVisibleColumns">
					<p style="text-align:center; margin: 5px 0 0 5px">
						No hay información que mostrar
					</p>
				</td>
			</tr>
		</tfoot>
	</table>
</template>

<script>

import TableColumnItem from './table-column-item';
import helper from './../../../shared/helper';

const ADD_REQUEST_EVENT = 'on-add-event';
const LOCAL_SEARCH_EVENT = 'on-local-search';
const SEARCH_EVENT = 'on-search-event';
const ON_DRAG_EVENT = 'on-drag-event';
const ON_DRAG_ENTER = 'on-drag-enter';
const ON_DRAG_LEAVE = 'on-drag-leave';
const ON_DROP_EVENT = 'on-drop-event';
const ON_PAGE_EVENT = 'on-page';
const ROW_IS_SELECTED = 'row-is-selected';
const SELECTED_ALL_EVENT = 'on-selected-all';
const TABLE_OPTION_EVENT = 'table-option-event';

const components = {
	TableColumnItem,
};

function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}

function pagination(pageNumber, totalRecords) {
	const current = pageNumber;
	const last = totalRecords;
	const delta = 2;
	const left = current - delta;
	const right = current + delta + 1;
	const range = [];
	const rangeWithDots = [];
	let l = null;

	for (let i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}

	/* eslint-disable no-restricted-syntax */
	for (const i of range) {
		if (l) {
			if (i - l === 2) {
				rangeWithDots.push(l + 1);
			} else if (i - l !== 1) {
				rangeWithDots.push('...');
			}
		}
		rangeWithDots.push(i);
		l = i;
	}

	return rangeWithDots;
}

function data() {
	return {
		direction: 'right',
		search: '',
		showMenu: false,
	};
}

function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	this.optionsDirection();
	const columnsInLocalStorage = helper.getLocalData(`${this.$attrs.name}::columns`);
	if (columnsInLocalStorage) {
		this.columns.forEach((col) => {
			const newCol = col;
			const colToChange = columnsInLocalStorage.find(c => c.id === newCol.id);
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		const searchFromLocalStorage = helper.getLocalData(`${this.$attrs.name}::search`);
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
}

function toggleColumns() {
	this.selectedColumns = this.columns.filter(c => !c.checked);
	this.columns.forEach((col) => {
		const newCol = col;
		const colToChange = this.selectedColumns.find(c => c.id === newCol.id);
		newCol.visible = typeof colToChange === 'undefined';
	});
	helper.setLocalData(`${this.$attrs.name}::columns`, this.selectedColumns);
	this.showMenu = false;
}

function selectedAll({ target }) {
	this.$emit(SELECTED_ALL_EVENT, target.checked);
}

function rowIsSelected(row) {
	const newRow = { ...row };
	newRow[this.selectedValue] = !newRow[this.selectedValue];
	this.$emit(ROW_IS_SELECTED, newRow);
}

function searchRows($event) {
	const keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		const dataToLocalSearch = this.search.toLowerCase();
		helper.setLocalData(`${this.$attrs.name}::search`, dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		helper.setLocalData(`${this.$attrs.name}::search`, this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}

function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}

function selectPage(page) {
	let newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}

function selectLastPage() {
	changePage.call(this, this.lastPage);
}

function tableOption() {
	const action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		imgSrc: `${this.$imageUrl}/close.svg`,
		open: true,
		title: 'FILTRAR POR',
		width: 229,
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}

function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'left';
	} else {
		this.direction = 'right';
	}
}

function totalVisibleColumns() {
	return this.columns.filter(c => c.visible).length + 1;
}

function pages() {
	return pagination(this.currentPage, this.lastPage);
}

export default {
	name: 'app-table',
	components,
	computed: {
		pages,
		totalVisibleColumns,
	},
	data,
	methods: {
		addOption,
		onDrag,
		onDragEnter,
		onDragLeave,
		onDrop,
		optionsDirection,
		rowIsSelected,
		searchRows,
		selectedAll,
		selectPage,
		selectLastPage,
		tableOption,
		toggleColumns,
	},
	mounted,
	props: {
		addButton: {
			default: false,
			type: Boolean,
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		dispatchDetail: {
			default: false,
			type: Boolean,
		},
		filterColumns: {
			default: true,
			type: Boolean,
		},
		includeFilter: {
			type: Boolean,
			default: false,
		},
		inputSearch: {
			default: true,
			type: Boolean,
		},
		localSearch: {
			type: Boolean,
			default: false,
		},
		localStorage: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Array,
			required: true,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		keyValue: {
			type: String,
			default: 'id',
		},
		mainList: {
			type: Boolean,
			default: true,
		},
		disabledTable: {
			type: Boolean,
			default: false,
		},
		cleanSearch: {
			default: false,
			type: Boolean,
		},
		selectedValue: {
			default: 'isSelected',
			type: String,
		},
		rowMaintenance: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		cleanSearch,
	},
};

</script>

<style lang="scss" scoped>
	input {
		background-color: transparent;
		border-style: none;
	}

	table.table-list {
		width: 100%;

		thead {
			color: white;

			th {
				align-items: center;
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;
				font-weight: 500;
				height: 30.5px;
				padding: 0px 5px;
				text-align: center;

				&:first-child {
					padding-left: 9px;
					text-align: left;
					width: 34px;
				}

				.check-list {
					margin-top: -1px !important;
				}
			}

			tr:first-child {
				th {
					&:last-child {
						padding-right: 5px;
					}
				}
			}

			button {
				background-color: map-get($colors, success);
				border: 0px;
				border-radius: 4px;
				height: 22px;
				line-height: 22px;
				margin-left: 3px;
				outline: none;
				width: 25px;

				.icon {
					color: white;
					height: 20px;
					line-height: 19px;
				}
			}
		}

		&.is-not-selectable {
			th {
				&:first-child {
					width: auto;
				}
			}
		}

		tbody {
			tr {
				background-color: white;
				color: map-get($colors, tableText);
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;

				&:nth-child(odd) {
					background: #f2f2f2;
				}

				td {
					align-items: center;
					border-right: 1px solid map-get($colors, grey-border);
					height: 30px;
					padding: 0px 5px;
					text-align: center;

					&:first-child:not(.is-not-selectable) {
						border-left: 1px solid transparent;
						border-right: 0px;
						padding-left: 8px;
						text-align: left;
						width: 34px;
					}

					&:last-child {
						border-right: 1px solid transparent;
					}

					.check-list {
						margin-top: -1px !important;
					}

					.table-icon {
						img {
							vertical-align: middle;
						}

						&.btn {
							background-color: transparent;
							box-shadow: none;
							margin: 0px;
							min-width: auto;
						}
					}
				}

				&:hover {
					td:not(.td-employee) {
						border-bottom: 1px solid map-get($colors, primary);
						border-top: 1px solid map-get($colors, primary);
						color: black;
						font-family: map-get($fonts, opens-bold);

						&:first-child {
							border-left: 1px solid map-get($colors, primary);
						}

						&:last-child {
							border-right: 1px solid map-get($colors, primary) !important;
						}
					}
				}
			}

			tr.is-select {
				td:not(.td-employee) {
					border-bottom: 1px solid map-get($colors, primary);
					border-top: 1px solid map-get($colors, primary);
					color: grey;
					font-family: map-get($fonts, opens-regular);

					&:first-child {
						border-left: 1px solid map-get($colors, primary);
					}

					&:last-child {
						border-right: 1px solid map-get($colors, primary);
					}
				}

				&-employee {
					td.td-employee {
						border-bottom: 1px solid map-get($colors, primary);
						border-top: 1px solid map-get($colors, primary);
						color: grey;
						font-family: map-get($fonts, opens-regular);

						&:first-child {
							border-left: 1px solid map-get($colors, primary);
						}

						&:last-child {
							border-right: 1px solid map-get($colors, primary);
						}
					}
				}
			}
		}

		tfoot {
			tr {
				td {
					background-color: white;
					border-bottom-left-radius: 10px;
					border-bottom-right-radius: 10px;
					border-top: 1px solid map-get($colors, subheaderText);
					box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .2);
					height: 29px;
					padding-right: 17px;

					a {
						color: map-get($colors, paginationText);
						font-family: map-get($fonts, open-regular);
						font-size: 15px;
						font-weight: lighter;
						line-height: 10px;
						margin-left: 7px;
						padding: 5px;

						& + span {
							color: map-get($colors, grey-border);

							& + a {
								margin-left: 0px;
							}
						}

						&.active-page {
							color: red;
						}
						&:hover {
							font-size: 18px;
						}
					}
				}
			}
		}

		&.no-main-list {
			border-bottom: 1px solid map-get($colors, grey-border);
		}

		.search-input {
			background-color: rgba(0, 0, 0, .2);
			box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, .2);
			border-radius: 3px;
			display: inline-flex;
			height: 23px;
			max-width: 153px;
			vertical-align: middle;

			input {
				color: white;
				font-size: 14px;
				outline: none;
				padding: 0 5px;
				width: calc(100% - 25px);
			}

			.icon {
				align-self: center;
				color: white;
				font-size: 20px;
				transform: rotate(90deg);
			}
		}

		.checkbox {
			.icon {
				font-size: 14px;
			}

			.input-group--selection-controls__ripple {
				height: 15px;
				left: 13px;
				width: 15px;
			}
		}

		.input-checkbox {
			border: 1px solid map-get($colors, grey-border);
			border-radius: 1px;
			height: 12px;
			width: 12px;
		}
	}
	.unique-input {
		border: 1px solid map-get($colors, black);
		opacity: 0.1;
		padding-left: 5px;
		width: 50px;
	}
	.unique-input:focus-within{
		opacity: 1;
	}
	.row-checked {
		background-color: map-get($colors, rowSelected) !important;
	}

	.row-maintenance {
		background-color: #f4f8af7d !important;
	}

	.content-checkbox {
		background-color: white !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/table/app-table.vue